export function buildGavKurzSummaryGroups(details, toPlainText) {
  const hasGavKurzContent = value => {
    if (value == null) {
      return false
    }
    const normalized = toPlainText(String(value))
      .replace(/\u00a0/g, ' ')
      .trim()
    return normalized.length > 0 && normalized !== '-'
  }

  const resolveGavKurzContent = (candidateKeys = []) => {
    if (!details || !Array.isArray(candidateKeys) || candidateKeys.length === 0) {
      return ''
    }
    for (const key of candidateKeys) {
      const value = details[key]
      if (hasGavKurzContent(value)) {
        return value
      }
    }
    return ''
  }

  const groups = [
    {
      id: 'geltungsbereich',
      titleKey: 'mindestlohnrechner.details.gavKurz.groups.geltungsbereich',
      items: [
        {
          id: 'geltungsbereichBetrieblich',
          titleKey: 'mindestlohnrechner.ergebnis.accordion.betrieblich',
          candidateKeys: ['geltungsbereichBetrieblich', 'geltungsbereich_betrieblich']
        },
        {
          id: 'geltungsbereichPersoenlich',
          titleKey: 'mindestlohnrechner.ergebnis.accordion.persoenlich',
          candidateKeys: ['geltungsbereichPersoenlich', 'geltungsbereich_persoenlich']
        }
      ]
    },
    {
      id: 'arbeitszeit',
      titleKey: 'mindestlohnrechner.details.gavKurz.groups.arbeitszeitUndFreieTage',
      items: [
        {
          id: 'arbeitszeit',
          titleKey: 'mindestlohnrechner.details.gavKurz.topics.arbeitszeit',
          candidateKeys: ['arbeitszeit']
        },
        {
          id: 'ueberstunden',
          titleKey: 'mindestlohnrechner.details.gavKurz.topics.ueberstundenUeberzeit',
          candidateKeys: ['ueberstundenUeberzeit', 'ueberstunden', 'ueberzeit', 'uberstundenUberzeit']
        },
        {
          id: 'nachtarbeit',
          titleKey: 'mindestlohnrechner.details.gavKurz.topics.nachtarbeitWochenendarbeit',
          candidateKeys: ['nachtarbeitWochenendarbeit', 'nachtarbeit', 'wochenendarbeit']
        },
        {
          id: 'schichtarbeit',
          titleKey: 'mindestlohnrechner.details.gavKurz.topics.schichtarbeit',
          candidateKeys: ['schichtarbeit']
        },
        {
          id: 'ferien',
          titleKey: 'mindestlohnrechner.details.gavKurz.topics.ferien',
          candidateKeys: ['ferien']
        },
        {
          id: 'bezahlteArbeitsfreieTage',
          titleKey: 'mindestlohnrechner.details.gavKurz.topics.bezahlteArbeitsfreieTage',
          candidateKeys: ['bezahlteArbeitsfreieTage', 'bezahlteArbeitsfreieTag']
        },
        {
          id: 'mutterschaftElternurlaub',
          titleKey: 'mindestlohnrechner.details.gavKurz.topics.mutterschaftElternurlaub',
          candidateKeys: ['mutterschaftElternurlaub', 'mutterschaftsurlaub', 'elternurlaub']
        }
      ]
    },
    {
      id: 'lohn',
      titleKey: 'mindestlohnrechner.details.gavKurz.groups.lohnUndLohnbestandteile',
      items: [
        {
          id: 'loehne',
          titleKey: 'mindestlohnrechner.details.gavKurz.topics.loehneMindestloehne',
          candidateKeys: ['loehneMindestloehne', 'loehne', 'mindestloehne']
        },
        {
          id: 'lohnkategorien',
          titleKey: 'mindestlohnrechner.details.gavKurz.topics.lohnkategorien',
          candidateKeys: ['lohnkategorien']
        },
        {
          id: 'lohnerhoehungen',
          titleKey: 'mindestlohnrechner.details.gavKurz.topics.lohnerhoehungenTeuerungsausgleich',
          candidateKeys: ['lohnerhoehungenTeuerungsausgleich', 'lohnerhoehungen', 'teuerungsausgleich']
        },
        {
          id: 'jahresendzulage',
          titleKey: 'mindestlohnrechner.details.gavKurz.topics.jahresendzulage13MonatslohnGratifikation',
          candidateKeys: ['jahresendzulage13MonatslohnGratifikation', 'jahresendzulage', 'dreizehnterMonatslohn', 'gratifikation']
        },
        {
          id: 'kinderzulage',
          titleKey: 'mindestlohnrechner.details.gavKurz.topics.kinderzulage',
          candidateKeys: ['kinderzulage']
        },
        {
          id: 'spesenentschaedigung',
          titleKey: 'mindestlohnrechner.details.gavKurz.topics.spesenentschaedigung',
          candidateKeys: ['spesenentschaedigung']
        }
      ]
    },
    {
      id: 'weitereBestimmungen',
      titleKey: 'mindestlohnrechner.details.gavKurz.groups.weitereBestimmungen',
      items: [
        {
          id: 'vollzugskostenWeiterbildungKaution',
          titleKey: 'mindestlohnrechner.details.gavKurz.topics.vollzugskostenWeiterbildungKaution',
          candidateKeys: ['vollzugskostenWeiterbildungKaution']
        },
        {
          id: 'folgeBeiVertragsverletzung',
          titleKey: 'mindestlohnrechner.details.gavKurz.topics.folgeBeiVertragsverletzung',
          candidateKeys: ['folgeBeiVertragsverletzung', 'vertragsverletzungFolgen']
        }
      ]
    }
  ]

  return groups
    .map(group => ({
      ...group,
      items: group.items
        .map(item => ({
          ...item,
          content: resolveGavKurzContent(item.candidateKeys)
        }))
        .filter(item => hasGavKurzContent(item.content))
    }))
    .filter(group => group.items.length > 0)
}
